import Avatar from '@material-ui/core/Avatar';
import Box, { BoxProps } from '@material-ui/core/Box';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Typography from '@material-ui/core/Typography';
import * as React from 'react';
import { connect } from 'react-redux';

import LaserficheCredentials from '../models/LaserficheCredentials';
import { signOutUser } from '../store/actions';
import { State } from '../store/reducer';
import { getLaserficheDisplayInfo, getTitleState } from '../store/selectors';

export interface StateProps {
  laserficheDisplayInfo: Partial<LaserficheCredentials>;
  title: string;
}

export interface DispatchProps {
  onSignOut: () => void;
}

type Props = StateProps & DispatchProps & BoxProps;
declare const zE: any;
export const SidebarHeader: React.FC<Props> = ({
  laserficheDisplayInfo,
  title,
  onSignOut,
  ...boxProps
}) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLImageElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  const activateZendesk = () => {
    if (!zE || !zE.activate) {
      return;
    }

    zE.activate({ hideOnClose: true });
  };

  const handleItemClose = (selectedOption: string) => {
    switch (selectedOption) {
      case 'request help':
        activateZendesk();
        break;
      case 'sign out':
        onSignOut();
        break;
      default:
        return;
    }
    setAnchorEl(null);
  };

  return (
    <Box
      {...boxProps}
      component="header"
      display="flex"
      flexDirection="row"
      alignItems="center"
      justifyContent="space-between"
      p={2}
    >
      <Typography component="h1" variant="h5">
        {title}
      </Typography>
      <Avatar aria-controls="avatar-menu" aria-haspopup="true" onClick={handleClick}>
        {laserficheDisplayInfo.initials}
      </Avatar>
      <Menu
        id="avatar-menu"
        anchorEl={anchorEl}
        keepMounted={true}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        getContentAnchorEl={null}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center'
        }}
      >
        <MenuItem disabled={true}>
          <Typography>{laserficheDisplayInfo.username}</Typography>
        </MenuItem>
        <MenuItem onClick={handleItemClose.bind(null, 'request help')}>
          <Typography>Request Help</Typography>
        </MenuItem>
        <MenuItem onClick={handleItemClose.bind(null, 'sign out')}>
          <Typography>Sign Out</Typography>
        </MenuItem>
      </Menu>
    </Box>
  );
};

const mapState = (state: State): StateProps => {
  return {
    title: getTitleState(state),
    laserficheDisplayInfo: getLaserficheDisplayInfo(state)
  };
};

const mapDispatch = {
  onSignOut: signOutUser
};

export default connect<StateProps, DispatchProps, {}, State>(
  mapState,
  mapDispatch
)(SidebarHeader);
